import React, { useState, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import axios from "axios";
import Widget from "../../../../components/Widget/Widget";

const Platforms = () => {
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async (firstLoad) => {
    if (firstLoad) {
      setLoading(true);
    }
    try {
      const response = await axios.get(
        "https://eadash.arabiansystems.com/api/Dashboard/Analytics/ActiveUsersPerPlatforms"
      );
      const transformedData =
        response.data.activePlatformsLast30Min.platforms.map((item) => ({
          name: item.name,
          y: item.count,
        }));
      setChartData(transformedData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData(true);
    const interval = setInterval(() => {
      fetchData(false);
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  const options = {
    chart: {
      type: "variablepie",
      height: 300,
      backgroundColor: "transparent",
    },
    credits: {
      enabled: false,
    },
    title: false,
    tooltip: {
      headerFormat: "",
      formatter: function () {
        return `<span style="color:{point.color}">\u25CF</span> <b> ${this.point.name}</b><br/>`;
      },
    },
    plotOptions: {
      variablepie: {
        allowPointSelect: true,
        cursor: "pointer",
        showInLegend: true,
        borderColor: null,
        dataLabels: {
          style: {
            color: "#e0e0e1",
            textOutline: null,
          },
        },
      },
    },
    colors: ["#4CAF50", "#FFC107", "#1E88E5"],
    legend: {
      align: "right",
      verticalAlign: "middle",
      layout: "vertical",
      itemStyle: {
        color: "rgba(244, 244, 245, 0.6)",
        fontWeight: 400,
      },
      itemHoverStyle: {
        color: "#cccccc",
      },
      itemMarginBottom: 5,
      symbolRadius: 0,
    },
    exporting: {
      enabled: false,
    },
    series: [
      {
        // minPointSize: 10,
        //innerSize: "40%",
        // zMin: 0,
        name: "No. Items",
        colorByPoint: true,
        data: chartData,
      },
    ],
  };

  return (
    <div className="pb-xlg h-100">
      <Widget
        fetchingData={loading}
        bodyClass="mt"
        className="mb-0 h-100"
        title={
          <>
            <div className="platforms">
              <img
                src="/icons/platforms.png"
                width={window.innerWidth < 1576 ? "40" : "60"}
              />
              <div className="flexCol">
                <h6 style={{ color: "#f4f4f599" }} className="m-0">
                  Users <span className="">Platforms</span>
                </h6>
                <div className="infoFlex">
                  <i
                    style={{ color: "#f4f4f599" }}
                    class="fa fa-info-circle"
                  ></i>
                  <p style={{ color: "#f4f4f599" }} className="m-0">
                    Based on data from the last 30 days
                  </p>
                </div>
              </div>
            </div>
          </>
        }
      >
        <HighchartsReact highcharts={Highcharts} options={options} />
      </Widget>
    </div>
  );
};

export default Platforms;
